import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {useIntl} from 'react-intl';
import {Menu} from './Menu';
import {BlogMenu} from './BlogMenu';
import {allLocaleLinks} from './data';
import type {ExtendedBlogCategories} from '../../../types/blogCategories';
import {TopBanner} from './TopBanner';
import {LocaleEnum} from '../../../types/locale';

const HeaderNavigation = styled.div`
  box-shadow: 0 2px 12px 0 rgba(36, 50, 66, 0.075);
`;

type HeaderPushContentProps = {
  hasBlogMenu: boolean;
  showTopBanner: boolean;
  bannerHeight: number;
};

//Menu height is 70px; BlogMenu height is 50px;
export const HeaderPushContent = styled.div<HeaderPushContentProps>`
  height: ${props => (props.hasBlogMenu || props.showTopBanner ? `${(props.bannerHeight || 50) + 70}px` : '70px')};
`;

type Props = {
  currentPathname: string;
  categories: ExtendedBlogCategories;
  topBanner: {
    text?: string;
    isVisible?: boolean;
  };
};

export const Header: React.FC<Props> = props => {
  const intl = useIntl();
  const hasBlogMenu = Boolean(props.categories);
  const bannerElementRef = useRef<HTMLDivElement>();
  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    setBannerHeight(bannerElementRef.current?.offsetHeight);
  }, []);

  const links = allLocaleLinks.get(intl.locale as LocaleEnum);

  return (
    <>
      <header data-testid='navigation-header' className='z-10 fixed w-full top-0'>
        {props.topBanner.isVisible && <TopBanner forwardedRef={bannerElementRef} text={props.topBanner.text} />}
        <HeaderNavigation className='bg-white'>
          <div className='container max-w-screen-xl max-lg:px-3'>
            <Menu links={links} currentPathname={props.currentPathname} />
          </div>
        </HeaderNavigation>
      </header>
      <HeaderPushContent hasBlogMenu={hasBlogMenu} showTopBanner={props.topBanner.isVisible} bannerHeight={bannerHeight} />
      {hasBlogMenu && <BlogMenu currentPathname={props.currentPathname} categories={props.categories} />}
    </>
  );
};
